import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../shared/header/header.component';

@Component({
    selector: 'app-parti-view',
    templateUrl: './parti-view.component.html',
    styleUrls: ['./parti-view.component.css'],
    imports: [
        HeaderComponent,
        RouterOutlet
    ],
    standalone: true
})
export class PartiViewComponent { }